'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchBoxError = exports.removeSearchboxHistoryItem = exports.searchPanelItemSelected = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.doLoadPanelData = doLoadPanelData;
exports.setDefaultLocation = setDefaultLocation;
exports.doSearchPanelItemSelected = doSearchPanelItemSelected;
exports.doSearchPanelRemoveHistoryItem = doSearchPanelRemoveHistoryItem;
exports.doAutocomplete = doAutocomplete;
exports.watchSearchBoxSagas = watchSearchBoxSagas;
exports.initiateSearchBox = initiateSearchBox;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _reactRouterRedux = require('react-router-redux');

var _bound = require('redux/saga/entities/bound');

var _helpers = require('redux/saga/helpers');

var _user = require('redux/saga/selectors/user');

var _locale = require('redux/modules/locale');

var _verify = require('helpers/verify');

var _deep = require('helpers/deep');

var _selectors = require('redux/saga/selectors');

var _reactRouter = require('react-router');

var _filters = require('features/Search/filters/filters.saga');

var _Search = require('features/Search/Search.constants');

var _SearchBox = require('./SearchBox.reducer');

var _SearchBox2 = require('./SearchBox.constants');

var _Search2 = require('../Search.reducer');

var _Search3 = require('../Search.helpers');

var _Search4 = require('../Search.route');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadPanelData),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(setDefaultLocation),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doSearchPanelItemSelected),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doSearchPanelRemoveHistoryItem),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doAutocomplete),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchSearchBoxSagas),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(initiateSearchBox);

var SEARCHBOX_ERROR = 'SEARCHBOX_ERROR';
var SEARCH_PANEL_ITEM_SELECTED = 'SEARCH_PANEL_ITEM_SELECTED';
var SEARCH_PANEL_REMOVE_HISTORY_ITEM = 'SEARCH_PANEL_REMOVE_HISTORY_ITEM';

var searchPanelItemSelected = exports.searchPanelItemSelected = function searchPanelItemSelected(panel, item) {
  return { type: SEARCH_PANEL_ITEM_SELECTED, panel: panel, item: item };
};
var removeSearchboxHistoryItem = exports.removeSearchboxHistoryItem = function removeSearchboxHistoryItem(itemType, itemId) {
  return { type: SEARCH_PANEL_REMOVE_HISTORY_ITEM, itemType: itemType, itemId: itemId };
};
var searchBoxError = exports.searchBoxError = _helpers.errorActionCreator.bind(null, SEARCHBOX_ERROR);

function doLoadPanelData(client) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _ref, lat, lon, method;

  return _regenerator2.default.wrap(function doLoadPanelData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_SearchBox.selectActiveLocation);

        case 2:
          _context.t1 = _context.sent;

          if (_context.t1) {
            _context.next = 7;
            break;
          }

          _context.next = 6;
          return (0, _effects.select)(_locale.selectUserDetectedLocation);

        case 6:
          _context.t1 = _context.sent;

        case 7:
          _context.t0 = _context.t1;

          if (_context.t0) {
            _context.next = 10;
            break;
          }

          _context.t0 = _SearchBox2.DEFAULT_GEOLOCATION;

        case 10:
          _ref = _context.t0;
          lat = _ref.lat;
          lon = _ref.lon;
          method = force ? _sagaTools.fetchEntity : _sagaTools.fetchEntityIfNeeded;
          _context.next = 16;
          return (0, _effects.call)(method, _bound.searchLayoutByName, [client, _SearchBox2.HEADER_LAYOUT, {
            header_request: { location: { lat: lat, lon: lon } }
          }]);

        case 16:
          return _context.abrupt('return', _context.sent);

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function setDefaultLocation(client) {
  var headerData, defaultLocation;
  return _regenerator2.default.wrap(function setDefaultLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(doLoadPanelData, client);

        case 2:
          headerData = _context2.sent;
          defaultLocation = (0, _deep.deepExtract)('location_history.data.default_location', headerData, _SearchBox2.DEFAULT_GEOLOCATION);
          _context2.next = 6;
          return (0, _effects.put)((0, _SearchBox.setLocation)({
            locationName: defaultLocation.name,
            lat: defaultLocation.lat,
            lon: defaultLocation.lon,
            id: defaultLocation.place_id,
            timezone: defaultLocation.timezone
          }, true));

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doSearchPanelItemSelected(client, _ref2) {
  var panel = _ref2.panel,
      item = _ref2.item;

  var venue, lat, lon, timezone, _ref3, placeData, userId, currentPath;

  return _regenerator2.default.wrap(function doSearchPanelItemSelected$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!(panel === _SearchBox2.PANEL_NAMES.keyword)) {
            _context3.next = 26;
            break;
          }

          if (item) {
            _context3.next = 5;
            break;
          }

          console.log('Got request to clear keyword'); // eslint-disable-line no-console
          _context3.next = 24;
          break;

        case 5:
          if (!(item.type === _SearchBox2.ITEM_TYPES.venue)) {
            _context3.next = 13;
            break;
          }

          _context3.next = 8;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.venueByIdV2, [client, item.id]);

        case 8:
          venue = _context3.sent;
          _context3.next = 11;
          return (0, _effects.call)(_helpers.gtmSafeRedirect, '/studios/' + venue.alias);

        case 11:
          _context3.next = 24;
          break;

        case 13:
          if (!(item.type === _SearchBox2.ITEM_TYPES.activity)) {
            _context3.next = 21;
            break;
          }

          if (!item.vertical) {
            _context3.next = 17;
            break;
          }

          _context3.next = 17;
          return (0, _effects.put)(_filters.searchFilterActions.setFilterValue(_Search.FILTER_NAMES.VERTICAL, item.vertical));

        case 17:
          _context3.next = 19;
          return (0, _effects.put)((0, _SearchBox.setKeyword)(item));

        case 19:
          _context3.next = 24;
          break;

        case 21:
          if (!(item.type === _SearchBox2.ITEM_TYPES.links && item.to)) {
            _context3.next = 24;
            break;
          }

          _context3.next = 24;
          return (0, _effects.call)(_reactRouter.browserHistory.push, item.to);

        case 24:
          _context3.next = 48;
          break;

        case 26:
          if (!(panel === _SearchBox2.PANEL_NAMES.location)) {
            _context3.next = 48;
            break;
          }

          if (item) {
            _context3.next = 31;
            break;
          }

          console.log('Got request to clear location'); // eslint-disable-line no-console
          _context3.next = 48;
          break;

        case 31:
          lat = item.lat, lon = item.lon, timezone = item.timezone;

          if (!(!lat || !lon)) {
            _context3.next = 40;
            break;
          }

          _context3.next = 35;
          return (0, _effects.call)(client.search.location.details, item.place_id);

        case 35:
          _ref3 = _context3.sent;
          placeData = _ref3.data;

          lat = placeData.lat;
          lon = placeData.lon;
          timezone = placeData.timezone;

        case 40:
          _context3.next = 42;
          return (0, _effects.put)((0, _SearchBox.setLocation)({
            locationName: item.main_text,
            id: item.place_id,
            lat: lat,
            lon: lon,
            timezone: timezone
          }));

        case 42:
          _context3.next = 44;
          return (0, _effects.call)(_helpers.getUserId, client);

        case 44:
          userId = _context3.sent;

          if (!userId) {
            _context3.next = 48;
            break;
          }

          _context3.next = 48;
          return (0, _effects.spawn)(client.search.location.saveForUser, userId, item.place_id);

        case 48:
          _context3.next = 50;
          return (0, _effects.put)(_bound.searchLayoutByName.resetAction({ key: _SearchBox2.HEADER_LAYOUT }));

        case 50:
          _context3.next = 52;
          return (0, _effects.select)(_selectors.pathSelector);

        case 52:
          currentPath = _context3.sent;

          if (!(currentPath.indexOf(_Search4.PATH) !== 0)) {
            _context3.next = 56;
            break;
          }

          _context3.next = 56;
          return (0, _effects.put)((0, _reactRouterRedux.push)(_Search4.PATH));

        case 56:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doSearchPanelRemoveHistoryItem(client, _ref4) {
  var itemType = _ref4.itemType,
      itemId = _ref4.itemId;
  var userId;
  return _regenerator2.default.wrap(function doSearchPanelRemoveHistoryItem$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_user.userId);

        case 2:
          userId = _context4.sent;
          _context4.prev = 3;

          if (!(itemType === _SearchBox2.ITEM_TYPES.location)) {
            _context4.next = 9;
            break;
          }

          _context4.next = 7;
          return (0, _effects.call)(client.search.location.removeHistoryItem, userId, itemId);

        case 7:
          _context4.next = 11;
          break;

        case 9:
          _context4.next = 11;
          return (0, _effects.call)(client.search.keyword.removeHistoryItem, userId, itemId);

        case 11:
          _context4.next = 15;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4['catch'](3);

        case 15:
          _context4.next = 17;
          return (0, _effects.call)(doLoadPanelData, client, true);

        case 17:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[3, 13]]);
}

function doAutocomplete(panel, client, _ref5) {
  var value = _ref5.value;

  var openPanel, _ref6, lat, lon;

  return _regenerator2.default.wrap(function doAutocomplete$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.select)(_SearchBox.selectOpenPanel);

        case 3:
          openPanel = _context5.sent;

          if (!(openPanel === panel && !(0, _verify.isBlank)(value))) {
            _context5.next = 22;
            break;
          }

          _context5.next = 7;
          return (0, _effects.call)(_reduxSaga.delay, 50);

        case 7:
          _context5.next = 9;
          return (0, _effects.select)(_SearchBox.selectActiveLocation);

        case 9:
          _ref6 = _context5.sent;
          lat = _ref6.lat;
          lon = _ref6.lon;

          if (!(panel === _SearchBox2.PANEL_NAMES.keyword)) {
            _context5.next = 19;
            break;
          }

          _context5.next = 15;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.keywordAutocomplete, [client, value, {
            lat: lat, lon: lon
          }], { key: value });

        case 15:
          _context5.next = 17;
          return (0, _effects.put)((0, _SearchBox.setKeywordKey)(value));

        case 17:
          _context5.next = 22;
          break;

        case 19:
          if (!(panel === _SearchBox2.PANEL_NAMES.location)) {
            _context5.next = 22;
            break;
          }

          _context5.next = 22;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.searchLocationAutocomplete, [client, {
            query: value,
            near: {
              lat: lat, lon: lon
            }
          }], { key: value });

        case 22:
          _context5.next = 26;
          break;

        case 24:
          _context5.prev = 24;
          _context5.t0 = _context5['catch'](0);

        case 26:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[0, 24]]);
}

function watchSearchBoxSagas(client) {
  return _regenerator2.default.wrap(function watchSearchBoxSagas$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, SEARCH_PANEL_ITEM_SELECTED, doSearchPanelItemSelected, client);

        case 2:
          _context6.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, SEARCH_PANEL_REMOVE_HISTORY_ITEM, doSearchPanelRemoveHistoryItem, client);

        case 4:
          _context6.next = 6;
          return (0, _effects.fork)(_effects.takeEvery, _SearchBox.SET_OPEN_PANEL, doLoadPanelData, client, false);

        case 6:
          _context6.next = 8;
          return (0, _effects.fork)(_effects.takeLatest, _SearchBox.SET_KEYWORD_VALUE, doAutocomplete, _SearchBox2.PANEL_NAMES.keyword, client);

        case 8:
          _context6.next = 10;
          return (0, _effects.fork)(_effects.takeLatest, _SearchBox.SET_LOCATION_VALUE, doAutocomplete, _SearchBox2.PANEL_NAMES.location, client);

        case 10:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function initiateSearchBox(client) {
  var _ref7, _ref8, _ref8$, tags, lat, lon, placeId;

  return _regenerator2.default.wrap(function initiateSearchBox$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)((0, _Search2.setFilterModificationSemaphore)(true));

        case 2:
          _context7.next = 4;
          return (0, _effects.all)([(0, _effects.select)(_Search3.selectFiltersFromHash), (0, _effects.select)(_Search3.selectLocationAutoCompleteFromHash)]);

        case 4:
          _ref7 = _context7.sent;
          _ref8 = (0, _slicedToArray3.default)(_ref7, 2);
          _ref8$ = _ref8[0];
          tags = _ref8$.tag;
          lat = _ref8$.lat;
          lon = _ref8$.lon;
          placeId = _ref8[1].place_id;

          if (!(lat && lon)) {
            _context7.next = 31;
            break;
          }

          _context7.t0 = _effects.put;
          _context7.t1 = _SearchBox.setLocation;
          _context7.t2 = lat;
          _context7.t3 = lon;
          _context7.t4 = _effects.call;
          _context7.t5 = _Search3.selectLocationAutocompleteValueInLayout;
          _context7.next = 20;
          return (0, _effects.select)(_Search3.selectResultsFromLayout);

        case 20:
          _context7.t6 = _context7.sent;
          _context7.next = 23;
          return (0, _context7.t4)(_context7.t5, _context7.t6);

        case 23:
          _context7.t7 = _context7.sent;
          _context7.t8 = placeId;
          _context7.t9 = {
            lat: _context7.t2,
            lon: _context7.t3,
            locationName: _context7.t7,
            id: _context7.t8
          };
          _context7.t10 = (0, _context7.t1)(_context7.t9);
          _context7.next = 29;
          return (0, _context7.t0)(_context7.t10);

        case 29:
          _context7.next = 33;
          break;

        case 31:
          _context7.next = 33;
          return (0, _effects.call)(setDefaultLocation, client);

        case 33:
          if (!(tags && tags.length === 1)) {
            _context7.next = 49;
            break;
          }

          _context7.t11 = _effects.put;
          _context7.t12 = _SearchBox.setKeyword;
          _context7.t13 = tags[0];
          _context7.t14 = _effects.call;
          _context7.t15 = _Search3.selectKeywordAutocompleteValueInLayout;
          _context7.next = 41;
          return (0, _effects.select)(_Search3.selectResultsFromLayout);

        case 41:
          _context7.t16 = _context7.sent;
          _context7.next = 44;
          return (0, _context7.t14)(_context7.t15, _context7.t16);

        case 44:
          _context7.t17 = _context7.sent;
          _context7.t18 = {
            id: _context7.t13,
            name: _context7.t17
          };
          _context7.t19 = (0, _context7.t12)(_context7.t18);
          _context7.next = 49;
          return (0, _context7.t11)(_context7.t19);

        case 49:
          _context7.next = 51;
          return (0, _effects.put)((0, _Search2.setFilterModificationSemaphore)(false));

        case 51:
          _context7.next = 53;
          return (0, _effects.spawn)(watchSearchBoxSagas, client);

        case 53:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}